import React from 'react';
import { Modal } from './BaseModal';

interface GenericPopupProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const GenericPopup: React.FC<GenericPopupProps> = ({ isOpen, onClose, children }) => {
  return (
    <Modal active={isOpen} onClose={onClose} type="video_modal">
      {children}
    </Modal>
  );
};